import { GetStaticProps, InferGetStaticPropsType, GetStaticPaths } from 'next';
import { useRouter } from 'next/router';

import { useCanonical } from '@hooks';
import { PostListPage } from '@components';
import {
  getAllCategoryNamesAndSlugs2,
  getHnaviOptions,
  getLatestPosts,
  getMostPopularPosts,
  getPosts,
  getTotalPostCount,
} from '@api';
import {
  calcPageCountFromPostCount,
  getPageOffset,
  PER_PAGE_FIRST,
  PER_PAGE_REST,
} from '@utils';
import { isBasePath } from '@paths';
import { isrRevalidateSec } from '@constants';
import { getHnaviContentCategoriesFromCategories } from '@helpers';

const Page: React.FC<InferGetStaticPropsType<typeof getStaticProps>> = (
  props
) => {
  const canonical = useCanonical();
  const router = useRouter();
  return (
    <PostListPage
      {...props}
      seoData={{ canonical }}
      showFirstPostAsHeroPost={props.pageNo === 1}
      pageCount={calcPageCountFromPostCount(
        props.posts.pageInfo?.offsetPagination?.total ?? 0
      )}
      isHomePage={isBasePath(router.asPath)}
    />
  );
};

export default Page;

export const getStaticProps = async ({
  params,
}: Parameters<GetStaticProps<any, { pageNo: string }>>[0]) => {
  const pageNo = Number(params?.pageNo) || 1;
  console.info(`getStaticProps /page/${pageNo}`);

  const categories = await getAllCategoryNamesAndSlugs2();

  return {
    props: {
      posts: await getPosts({
        where: {
          offsetPagination: {
            size: pageNo === 1 ? PER_PAGE_FIRST : PER_PAGE_REST,
            offset: getPageOffset(pageNo),
          },
        },
      }),
      categories,
      hnaviContentCategories:
        getHnaviContentCategoriesFromCategories(categories),
      latestPosts: await getLatestPosts(),
      popularPosts: await getMostPopularPosts(),
      hnaviOptions: await getHnaviOptions(),
      pageNo,
    },
    revalidate: isrRevalidateSec,
  };
};

export const getStaticPaths: GetStaticPaths<{ pageNo: string }> = async () => {
  const postCount = (await getTotalPostCount()) || 0;

  return {
    paths: new Array(calcPageCountFromPostCount(postCount))
      .fill(0)
      .map((_, i) => ({
        params: { pageNo: String(i + 1) },
      })),
    fallback: 'blocking',
  };
};
